import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=81681a88&scoped=true&"
import script from "./Restaurant.vue?vue&type=script&lang=js&"
export * from "./Restaurant.vue?vue&type=script&lang=js&"
import style0 from "./Restaurant.vue?vue&type=style&index=0&id=81681a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81681a88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VForm,VLayout,VSelect,VSwitch,VTextField})
